module.exports = __webpack_public_path__ + "static/img/naniungo-slide-18.255e9940.jpg";